
<div class="custom-select-wrap" [ngClass]="{'readonly': isReadOnly}">
    <div class="dropdown-wrapper" appMousedownOutside (mousedownOutside)="el.hidden = true">
        <div class="select-component" (click)="el.hidden = !el.hidden">
            <div class="selected-list">
                <span class="square" [style.background]="backgroundStyle"></span>
            </div>

            <span class="icon-arrow-down"></span>
        </div>

        <div class="dropdown" #el [ngClass]="dropdownClass" [hidden]=true>
            <div class="color-search-list">
                <ul class="search-list">
                    @for (item of colorValues; track item) {
                        <li>
                            @for (color of item.displayValues; track color) {
                                <span [style.background]="color" (click)="onColorSelected(color, el)"></span>
                            }
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
</div>
